import styled from "styled-components";

import { Item as UIItem } from "../../Item";

export const Wrapper = styled.ul`
  list-style: none;

  li + li {
    margin-top: 1rem;
  }
`;

export const File = styled.li`
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Name = styled.span`
  font-size: 1rem;
  max-width: calc(100% - 7.5rem);
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Actions = styled.div`
  a {
    color: var(--gray20);
    margin-right: 1rem;
  }

  i {
    cursor: pointer;
  }
`;

export const Description = styled.div.attrs({ className: "file-description" })`
  display: inline-block;
  margin-right: 1rem;
`;

export const DescriptionItem = styled(UIItem)`
  padding: 0.875rem;
  width: min(19rem, 100vw);
  position: absolute;
  background-color: var(--white);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
`;
